import { render, staticRenderFns } from "./footer_bar.vue?vue&type=template&id=eb3b56ac&scoped=true"
var script = {}
import style0 from "./footer_bar.vue?vue&type=style&index=0&id=eb3b56ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3b56ac",
  null
  
)

export default component.exports